import moment from "moment";
import jwt from "jsonwebtoken";

export default class Guest {

    constructor( guest ) {
        this.guest = guest;
    }

    authenticate( connection ) {
        return connection.spark.request({
            method: 'POST',
            service: 'hydra',
            resource: 'jwt/login',
            headers: {
                authorization: this.token()
            }
        })
    }

    token() {
        return jwt.sign({
                'sub': this.guest.slug,
                'name': `${this.guest.firstname} - ${this.guest.lastname} - MR Guest`,
                'iss': 'Y2lzY29zcGFyazovL3VzL09SR0FOSVpBVElPTi9iYjJkMTNkMy0xOWJlLTQ1NzMtYTdjYi01ZjU4N2VhOWI3NWM',
                'exp': moment().add(24, 'hours').unix()
            },
            Buffer.from('sl2fyNewfmDEGr79e4C/OaAvN5mviDBeMD+llNHYEQw=', 'base64')
        )
    }
}